exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles--newYear__1OIwb{background-image:url(\"/public/images/_anti/events/new_year/snow.svg\");background-size:cover;background-repeat:no-repeat}.styles--lightsContainer__1Qnw4{position:relative}.styles--lights__3IKuj{display:none;position:absolute;top:0;left:-120px}@media screen and (min-width: 360px){.styles--lights__3IKuj{display:block}}\n", ""]);

// exports
exports.locals = {
	"newYear": "styles--newYear__1OIwb",
	"lightsContainer": "styles--lightsContainer__1Qnw4",
	"lights": "styles--lights__3IKuj"
};